export const HEAD_TABLE_PROPS = [
  {
    id: 'name',
    label: 'Tên file',
    align: 'left',
  },
  {
    id: 'createdAt',
    label: 'Ngày tải',
    align: 'left',
  },
  {
    id: 'email',
    label: 'Email đã tải',
    align: 'left',
  },
];
export const defaultValueSearch = {
  fileName: null,
  startDate: null,
  endDate: null,
};
